// export function groupEventsByDate(events) {
//   if (!Array.isArray(events)) return {};

//   return events.reduce((groups, event) => {
//     const date = new Date(event.timestamp * 1000); // supponendo timestamp in epoch seconds
//     const formattedDate = date.toLocaleDateString("it-IT", {
//       weekday: "long",
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });

//     if (!groups[formattedDate]) {
//       groups[formattedDate] = [];
//     }
//     groups[formattedDate].push(event);

//     return groups;
//   }, {});
// }

export function groupEventsByDate(events, useRelativeLabels = true) {
  if (!Array.isArray(events)) return {};

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  return events.reduce((groups, event) => {
    const date = new Date(event.timestamp * 1000); // epoch seconds → ms
    const eventDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    let label;
    if (useRelativeLabels) {
      if (eventDay.getTime() === today.getTime()) {
        label = "Oggi";
      } else if (eventDay.getTime() === yesterday.getTime()) {
        label = "Ieri";
      }
    }

    // Se non è oggi o ieri, formattiamo la data estesa
    if (!label) {
      label = date.toLocaleDateString("it-IT", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }

    // Aggiunge l'evento nel gruppo corrispondente
    if (!groups[label]) {
      groups[label] = [];
    }
    groups[label].push(event);

    return groups;
  }, {});
}
